import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { ApiResponse, UserState } from "models";

const initialState: UserState = {
  loading: false,
  editloading: false,
  deleteloading: false,
  data: {},
  message: "",
  success: false,
  imageUrl: "",
  updateMessage: "",
};

const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    getUsers(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getUserSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.data = action.payload;
      state.success = action.payload.success;
    },
    getUserFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    updateUser(state, action: PayloadAction<ApiResponse>) {
      state.editloading = true;
      state.updateMessage = "";
    },
    updateUserSuccess(state, action: PayloadAction<ApiResponse>) {
      state.editloading = false;
      state.success = action.payload.success;
      state.updateMessage = action.payload.message;
    },
    updateUserFailed(state, action: PayloadAction<ApiResponse>) {
      state.editloading = false;
      state.updateMessage = action.payload.message;
      state.success = action.payload.success;
    },
    deleteUser(state, action: PayloadAction<ApiResponse>) {
      state.deleteloading = true;
      state.deleteMessage = "";
    },
    deleteUserSuccess(state, action: PayloadAction<ApiResponse>) {
      state.deleteloading = false;
      state.deleteMessage = action.payload.message;
      state.success = action.payload.success;
    },
    deleteUserFailed(state, action: PayloadAction<ApiResponse>) {
      state.deleteloading = false;
      state.deleteMessage = action.payload.message;
      state.success = action.payload.success;
    },
    clearData(state) {
      state.loading = false;
      state.deleteloading = false;
      state.message = "";
      state.success = false;
      state.updateMessage = "";
      state.deleteMessage = "";
    },
  },
});

//Actions
export const userActions = userSlice.actions;

//Selectors
export const getUsersData = (state: RootState) => state.users.data;
export const selectIsLoading = (state: RootState) => state.users.loading;
export const selectIsDeleteLoading = (state: RootState) =>
  state.users.deleteloading;
export const selectIsEditLoading = (state: RootState) =>
  state.users.editloading;
export const selectIsSuccess = (state: RootState) => state.users.success;
export const selectMessage = (state: RootState) => state.users.message;
export const selectImageUrl = (state: RootState) => state.users.imageUrl;
export const selectUpdateMessage = (state: RootState) =>
  state.users.updateMessage;

//Reducers
const userReducer = userSlice.reducer;
export default userReducer;
